import { Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import sha256 from 'crypto-js/sha256';
import { Subscription } from 'rxjs';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { UsersUserChangePasswordDialogComponent } from 'src/app/components/users-components/users-user-change-password-dialog/users-user-change-password-dialog.component';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';

@Component({
  selector: 'app-users-user-info-card',
  templateUrl: './users-user-info-card.component.html',
  styleUrls: ['./users-user-info-card.component.scss']
})
export class UsersUserInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() user;
  showImageSpinner: boolean;
  editingLocked: boolean;
  width: number;
  height: number;
  base64;
  showButton: boolean;
  updateUserSubscription: Subscription;
  updateUserImageSubscription: Subscription;
  updateUserPasswordSubscription: Subscription;

  basicDataForm = new FormGroup({
    firstname: new FormControl({ value: null, disabled: true }, Validators.required),
    lastname: new FormControl({ value: null, disabled: true }, Validators.required),
    username: new FormControl({ value: null, disabled: true }, Validators.required),
    email: new FormControl({ value: null, disabled: true }, Validators.email)
  });

  constructor(private validationImageService: ValidationImageService,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private userService: UserService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog,
    private eRef: ElementRef) {
    this.editingLocked = true;
    this.showButton = true;
    this.width = 200;
    this.height = 200;
  }

  ngOnInit() { }

  ngOnChanges() {
    if (this.user) {
      this.base64 = this.user.UserImage;
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {

    } else {
      if (this.notUserPasswordChangeDialog(event) && this.notFromImageCropperDialog(event) && (event.path[0].className !== 'cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing')) {
        if (this.user && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
          this.editingLocked = true;
        }
      }
    }
  }

  public submitForm() {
    this.updateUserSubscription = this.userService.updateUser(this.user.InternalId, this.userStorageService.getCompanyData().CompanyCode, this.basicDataForm.get('firstname').value, this.basicDataForm.get('lastname').value, this.basicDataForm.get('username').value.toLowerCase(), this.basicDataForm.get('email').value).subscribe(
      (res) => {
        if (this.base64) {
          this.updateUserImageSubscription = this.userService.updateUserImage(this.user.InternalId, this.base64).subscribe(
            (res2) => {
              this.lockEdition();
              this.snackbarService.open('users-page.snackbar messages.update user success', 'success');
            },
            (error) => {
              this.snackbarService.open(error['error']['message'], 'error');
            }
          );
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public changePassword() {
    this.showButton = false;
    this.spinnerService.show('change-password-spinner');
    const dialogRef = this.dialog.open(UsersUserChangePasswordDialogComponent, { data: this.user.InternalId });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateUserPasswordSubscription = this.userService.updateUserPassword(this.user.InternalId, sha256(result.newPassword.value).toString().toUpperCase()).subscribe(
          (res) => {
            this.showButton = true;
            this.spinnerService.hide('change-password-spinner');
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
            this.showButton = true;
            this.spinnerService.hide('change-password-spinner');
          }
        );
      } else {
        this.showButton = true;
        this.spinnerService.hide('change-password-spinner');

      }
    });
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      firstname: this.user.Firstname,
      lastname: this.user.Lastname,
      username: this.user.Username,
      email: this.user.Email
    });
    this.base64 = this.user.UserImage;
  }

  public unlockEdition() {
    this.basicDataForm.get('firstname').enable();
    this.basicDataForm.get('lastname').enable();
    this.basicDataForm.get('username').enable();
    this.basicDataForm.get('email').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('firstname').disable();
    this.basicDataForm.get('lastname').disable();
    this.basicDataForm.get('username').disable();
    this.basicDataForm.get('email').disable();
    this.editingLocked = true;
  }

  public validateForm() {
    if (!this.basicDataForm.get('username').valid) {
      return 'users-page.snackbar messages.username required error';
    } else if (!this.basicDataForm.get('firstname').valid) {
      return 'users-page.snackbar messages.firstname required error';
    } else if (!this.basicDataForm.get('lastname').valid) {
      return 'users-page.snackbar messages.lastname required error';
    } else if (!this.basicDataForm.get('email').valid) {
      return 'users-page.snackbar messages.email format error';
    } else {
      return true;
    }
  }

  public notFromImageCropperDialog(event) {
    for (const i of event.path) {
      if (i.className === 'image-cropper-dialog') {
        return false;
      }
    }
    return true;
  }

  public notUserPasswordChangeDialog(event) {
    for (const i of event.path) {
      if (i.className === 'user-change-password-dialog2') {
        return false;
      }
    }
    return true;
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    this.showImageSpinner = true;
    this.spinnerService.show('user-image-spinner');
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: this.width, height: this.height }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.base64 = result;
            this.showImageSpinner = false;
            this.spinnerService.hide('user-image-spinner');
          } else {
            this.showImageSpinner = false;
            this.spinnerService.hide('user-image-spinner');
          }
        });
      },
      (error) => {
        this.userService.refreshUser();
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public uploadPhotoClicker() {
    if (!this.editingLocked) {
      this.uploadInput.nativeElement.value = null;
      this.uploadInput.nativeElement.click();
    }
  }

  public toLowerCase(eRef) {
    eRef.value = eRef.value.toLowerCase();
  }

  ngOnDestroy() {
    if (this.updateUserSubscription) { this.updateUserSubscription.unsubscribe(); }
    if (this.updateUserImageSubscription) { this.updateUserImageSubscription.unsubscribe(); }
  }
}
